














































































































































































































import Component, {mixins} from "vue-class-component";
import {Rapport, RapportFav, TypeRapport} from "@/shared/Rapport";
import DateChooser from "@/components/dateChooser.vue";
import DateChooserCentral from "@/components/dateChooserCentral.vue";
import RapportSelection from "@/components/rapportSelection.vue";
import ListeSites from "@/components/listeSites.vue";
import CaisseChooser from "@/components/caisseChooser.vue";
import PdfViewer from "@/components/pdf-viewer.vue";
import RapportMixin from "@/mixins/rapportMixin";
import PdfReport from "@/shared/pdfReport";
import {Prop, Watch} from "vue-property-decorator";
import SelectedSites from "@/ui-component/selectedSites.vue";
import LocalChooser from "@/components/localChooser.vue";
import {Site} from "@/shared/Site";

@Component({
  components: {
    DateChooser,
    DateChooserCentral,
    RapportSelection,
    ListeSites,
    PdfViewer,
    SelectedSites,
    CaisseChooser,
    LocalChooser,
  },
})
export default class MobileRapportConfig extends mixins(RapportMixin) {
  public panel: string = "ou";
  public showRep = false;
  public panels = {0: "ou", 1: "quand", 2: "quoi"};
  public swiping: boolean = false;
  public dialogError: boolean = false;
  public avReports: any = {PDF_AVAILABLE: false, CSV_AVAILABLE: false};
  public pdfReport: PdfReport = new PdfReport();
  public allSelectedSites: Site[] = [];
  public allRapports: TypeRapport[] = [];
  public selectedReport: TypeRapport = {className: "", localisedTitle: ""};
  public descriptions = new Array();
  public showDtt: boolean = false;
  public allSites: Site[] = [];
  public filteredRapports: TypeRapport[] = [];
  public rapportParNbr: { [key: string]: number } = {};
  public searchTermRapports: string = "";
  public searchTermSites: string = "";

  @Prop({default: false}) public isFavoris!: boolean;

  @Watch("sites", {immediate: true})
  public onPropertyChangedSites(value: any, oldValue: any) {
    this.orderSites();
  }

  public handleSelectionChange() {
    this.orderSites();
    this.addSites(this.allSelectedSites);
  }

  public orderRapports() {
    let unselectedItems: TypeRapport[] = [];
    if (this.searchTermRapports) {
      unselectedItems = this.allRapports.filter(
          (item: TypeRapport) =>
              item.localisedTitle
                  .toLowerCase()
                  .indexOf(this.searchTermRapports.toLowerCase()) > -1
      );
    } else {
      unselectedItems = this.allRapports;
    }
    this.filteredRapports = unselectedItems;
    const keys = Object.keys(this.metrics);
    for (const key of keys) {
      const siteReps = this.metrics[key];
      for (const rap of Object.keys(siteReps)) {
        if (rap === "FeuilleCaisseReport" && this.client === "BK") {
          const name = "SyntheseCAReport";
          if (this.rapportParNbr[name] !== undefined) {
            this.rapportParNbr[name] += siteReps[rap];
          } else {
            this.rapportParNbr[name] = siteReps[rap];
          }
        } else if (this.rapportParNbr[rap] !== undefined) {
          this.rapportParNbr[rap] += siteReps[rap];
        } else {
          this.rapportParNbr[rap] = siteReps[rap];
        }
      }
    }
    // console.log(this.rapportParNbr);
    this.filteredRapports.sort((a: any, b: any) => {
      const splittedA = a.className.split(".");
      const aName = splittedA[splittedA.length - 1];
      const nbA = Object.keys(this.rapportParNbr).includes(aName)
          ? this.rapportParNbr[aName]
          : 0;
      const splittedB = b.className.split(".");
      const bName = splittedB[splittedB.length - 1];
      const nbB = Object.keys(this.rapportParNbr).includes(bName)
          ? this.rapportParNbr[bName]
          : 0;
      return nbB - nbA;
    });
    // console.log(this.filteredRapports);
  }

  public orderSites() {
    const selectedItems = this.allSelectedSites;
    let unselectedItems: Site[] = [];
    if (!this.searchTermSites) {
      unselectedItems = this.sites.filter(
          (item: Site) => !selectedItems.includes(item)
      );
    } else {
      unselectedItems = this.sites.filter(
          (item: Site) =>
              !selectedItems.includes(item) &&
              item.libelle
                  .toLowerCase()
                  .indexOf(this.searchTermSites.toLowerCase()) > -1
      );
    }
    this.allSites = selectedItems.concat(unselectedItems);
  }

  public async handleSelectionRapport() {
    await this.$store
        .dispatch("rapport/checkRapportType", this.selectedReport.className)
        .then((result: any) => {
          if (result.SAVE_FILTERS !== undefined) {
            this.$emit("saveFilters", result.SAVE_FILTERS);
          }
          if (result.CAN_SAVE_FILTERS !== undefined) {
            this.$emit("canSaveFilters", result.CAN_SAVE_FILTERS);
          }
          if (result.TRIS !== undefined) {
            this.$emit("tris", result.TRIS);
          }
          this.$emit("typeRapport", result);
          this.$emit("rapportSelected", this.selectedReport);

          if (result.DESCRIPTIONS !== undefined) {
            this.descriptions = result.DESCRIPTIONS;
            this.showDtt = true;
            // console.log("dtt ok");
          } else {
            this.getRapport.typeRapport.dttConfig = undefined;
          }
        });
    this.typeRapportSelected(this.selectedReport);
  }

  public mounted() {
    this.$store.dispatch("login/setLoading", true);
    if (this.sites.length === 1) {
      this.monrapport.lSites = this.sites;
      this.updateRapport(this.getRapport);
    }
    this.allRapports = Object.values(this.rapports).flat();
    this.orderSites();
    this.orderRapports();
    this.$store.dispatch("login/setLoading", false);
  }

  public searchSites() {
    this.orderSites();
  }

  public searchRapports() {
    this.orderRapports();
  }

  /*
   * methode de mise a jour du rapport selectionné dans la page parente
   */
  public updateRapport(rapport: Rapport | RapportFav) {
    this.$emit("updateRapport", rapport);
  }

  /**
   * methode permettant de switcher de panel du carousel a l'aide des point en bas de page
   */
  public activatePanel(value: string) {
    this.panel = value;
  }

  /**
   * methdoe permettant de faire disparaitre le dialogue contenant le rapport
   */
  public hide(target: any) {
    this.showRep = false;
  }

  /**
   * methode de gestion de l'evenement swipe
   */
  public swipe(evt: any) {
    let pane;
    switch (this.panel) {
      case "ou":
        pane = evt === "left" ? "quand" : "quoi";
        break;
      case "quand":
        pane = evt === "left" ? "quoi" : "ou";
        break;
      case "quoi":
        pane = evt === "left" ? "ou" : "quand";
        break;
      default:
        break;
    }
    this.setPane(pane);
  }

  /**
   * methode permettant de changer de panel dans le carrousel au swipe
   */
  private setPane(pane: any) {
    this.panel = pane;
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }

  get rapport(): Rapport {
    let rap;
    if (this.isFavoris) {
      rap = this.$store.getters["rapport/selectedFavoris"];
    } else {
      rap = this.$store.getters["rapport/rapport"];
    }
    return rap;
  }

  get rapports(): any[] {
    return this.$store.getters["rapport/allReports"];
  }

  get getRapport(): Rapport {
    return this.rapport;
  }

  get metrics(): { [key: string]: { [key: string]: number } } {
    return this.$store.getters["rapport/metrics"];
  }

  get loading(): boolean {
    return this.$store.getters["login/loading"];
  }
}
